// extracted by mini-css-extract-plugin
export var standaloneTable = "_e9-0";
export var standaloneTableWithBodyFill = "_e9-1";
export var withExtraHeader = "_e9-2";